<template>
  <div class="monitor-page">
    <div class="map-col">
      <TMapPicker mode="markers" :center="mapCenter" :markers="markers" :height="620" @marker-click="onMarker" />
    </div>
    <div class="side-col">
      <div class="side-head">
        <h3>设备列表</h3>
        <el-select v-model="fStatus" placeholder="全部状态" clearable size="small" style="width:130px" @change="filterMarkers">
          <el-option label="在线" value="online" />
          <el-option label="离线" value="offline" />
        </el-select>
      </div>
      <div class="dev-list">
        <div v-for="(m, i) in shownDevices" :key="i" class="dev-item" :class="{ active: activeId === m.id }" @click="locate(m)">
          <div class="di-dot" :class="m.status === 'online' ? 'on' : 'off'"></div>
          <div class="di-meta">
            <div class="di-name">{{ m.title }}</div>
            <div class="di-sub">{{ m.sn || '' }} · {{ m.status === 'online' ? '在线' : '离线' }}</div>
          </div>
          <div v-if="m.speed != null" class="di-speed">{{ m.speed }} m/s</div>
        </div>
        <div v-if="!shownDevices.length" class="no-dev">暂无设备</div>
      </div>
    </div>
  </div>
</template>

<script>
import TMapPicker from '@/views/components/TMapPicker.vue'
import { getMonitor } from '@/api/sentinel'

export default {
  name: 'MonitorIndex',
  components: { TMapPicker },
  data() {
    return {
      allDevices: [],
      markers: [],
      mapCenter: { lat: 30.2741, lng: 120.1551 },
      fStatus: '',
      activeId: ''
    }
  },
  mounted() {
    this.load()
  },
  computed: {
    shownDevices() {
      if (this.fStatus === 'online') return this.allDevices.filter(d => d.status === 'online')
      if (this.fStatus === 'offline') return this.allDevices.filter(d => d.status !== 'online')
      return this.allDevices
    }
  },
  methods: {
    load() {
      getMonitor().then(res => {
        if (res.code === 200) {
          const list = (res.data && (res.data.markers || res.data.devices)) || []
          this.allDevices = list.map(m => ({
            id: m.id,
            lat: +m.lat,
            lng: +m.lng,
            title: m.title || m.name || m.sn,
            sn: m.sn,
            status: m.status,
            speed: m.speed
          }))
          this.markers = this.allDevices
          if (this.allDevices.length) this.mapCenter = { lat: this.allDevices[0].lat, lng: this.allDevices[0].lng }
        }
      }).catch(() => {})
    },
    filterMarkers() {
      this.markers = this.shownDevices
    },
    locate(m) {
      this.activeId = m.id
      this.mapCenter = { lat: +m.lat, lng: +m.lng }
    },
    onMarker(item) {
      this.activeId = item.id
    }
  }
}
</script>

<style scoped>
.monitor-page { display: flex; gap: 16px; height: 100%; }
.map-col { flex: 1; min-width: 0; }
.side-col { width: 320px; flex-shrink: 0; background: #fff; border-radius: 4px; box-shadow: 0 2px 12px rgba(0,0,0,.1); display: flex; flex-direction: column; max-height: 660px; }
.side-head { display: flex; align-items: center; justify-content: space-between; padding: 14px 16px; border-bottom: 1px solid #ebeef5; }
.side-head h3 { margin: 0; font-size: 15px; color: #1D2129; }
.dev-list { flex: 1; overflow-y: auto; padding: 8px; }
.dev-item { display: flex; align-items: center; gap: 10px; padding: 12px; border-radius: 4px; cursor: pointer; }
.dev-item:hover, .dev-item.active { background: #f5f7fa; }
.di-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }
.di-dot.on { background: #00b42a; }
.di-dot.off { background: #c9cdd4; }
.di-meta { flex: 1; min-width: 0; }
.di-name { font-size: 14px; color: #1D2129; font-weight: 500; }
.di-sub { font-size: 12px; color: #86909c; margin-top: 2px; }
.di-speed { font-size: 13px; color: #165dff; }
.no-dev { text-align: center; color: #86909c; font-size: 13px; padding: 30px 0; }
@media (max-width: 768px) {
  .monitor-page { flex-direction: column; }
  .side-col { width: 100%; max-height: 320px; }
}
</style>
